import { render, staticRenderFns } from "./AdminRoles.vue?vue&type=template&id=2e96ba10&"
import script from "./AdminRoles.vue?vue&type=script&lang=js&"
export * from "./AdminRoles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports